import { PAGE_SUCCESS } from '../routes';
import { useApplicationStore } from "../stores/application-store";

export default async function redirectToSuccessPageIfAlreadySent() {
    const application = useApplicationStore();
    if (application.uuid) return { name: PAGE_SUCCESS };
    return true;
}
